import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  MenuItem,
} from '@mui/material';

const SupplierForm = ({ onSubmit, initialData = {}, isEdit = false }) => {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    phone: '',
    email: '',
    status: 'Active',
    primary_contact_name: '',
    primary_contact_email: '',
    primary_contact_phone: '',
  });

  useEffect(() => {
    if (initialData && initialData.id) {
      setFormData({
        name: initialData.name || '',
        address: initialData.address || '',
        phone: initialData.phone || '',
        email: initialData.email || '',
        status: initialData.status || 'Active',
        primary_contact_name: initialData.primary_contact_name || '',
        primary_contact_email: initialData.primary_contact_email || '',
        primary_contact_phone: initialData.primary_contact_phone || '',
      });
    }
  }, [initialData]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit(formData);
  };

  return (
    <Container component="main" maxWidth="sm">
      <Typography component="h1" variant="h5">
        {isEdit ? 'Chỉnh sửa nhà cung cấp' : 'Tạo mới nhà cung cấp'}
      </Typography>
      <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 3 }}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="name"
          label="Tên nhà cung cấp"
          name="name"
          value={formData.name}
          onChange={handleChange}
        />
        <TextField
          margin="normal"
          fullWidth
          id="address"
          label="Địa chỉ"
          name="address"
          value={formData.address}
          onChange={handleChange}
        />
        <TextField
          margin="normal"
          fullWidth
          id="phone"
          label="Số điện thoại"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
        />
        <TextField
          margin="normal"
          fullWidth
          id="email"
          label="Địa chỉ email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
        />
        <TextField
          margin="normal"
          fullWidth
          select
          id="status"
          name="status"
          label="Trạng thái"
          value={formData.status}
          onChange={handleChange}
        >
          <MenuItem value="Active">Hoạt động</MenuItem>
          <MenuItem value="Inactive">Không hoạt động</MenuItem>
        </TextField>
        <Typography component="h2" variant="h6" sx={{ mt: 3 }}>
          Thông tin liên hệ
        </Typography>
        <TextField
          margin="normal"
          fullWidth
          id="primary_contact_name"
          label="Tên người liên hệ"
          name="primary_contact_name"
          value={formData.primary_contact_name}
          onChange={handleChange}
        />
        <TextField
          margin="normal"
          fullWidth
          id="primary_contact_email"
          label="Email liên hệ"
          name="primary_contact_email"
          type="email"
          value={formData.primary_contact_email}
          onChange={handleChange}
        />
        <TextField
          margin="normal"
          fullWidth
          id="primary_contact_phone"
          label="SĐT liên hệ"
          name="primary_contact_phone"
          value={formData.primary_contact_phone}
          onChange={handleChange}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          {isEdit ? 'Cập nhật' : 'Tạo mới'}
        </Button>
      </Box>
    </Container>
  );
};

export default SupplierForm; 